export default "__VITE_ASSET__DPw7bKNS__"